import { SettingsTypes as Types, Settings } from "../types";

interface DefaultState extends Partial<Settings> {
  isFetching: boolean;
  isStoring: boolean;
}
const defaultState: DefaultState = {
  isFetching: false,
  isStoring: false,
};

function settingsReducer(state = defaultState, action: any): DefaultState {
  switch (action.type) {
    case Types.GET_SETTINGS_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case Types.GET_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        isFetching: false,
      };
    case Types.GET_SETTINGS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case Types.UPDATE_SETTINGS_REQUEST:
      return {
        ...state,
        isStoring: true,
      };
    case Types.UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        isStoring: false,
      };
    case Types.UPDATE_SETTINGS_ERROR:
      return {
        ...state,
        isStoring: false,
      };
    default:
      return state;
  }
}

export default settingsReducer;
